import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { FaWhatsapp } from "react-icons/fa";

// TODO: Refactor ~/common/ui/Button to handle this component too.
function Button({ children, onClick, className }) {
  return (
    <button
      className={`rounded-md px-4 py-2 w-full ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default function CarInteractions({
  pageUrl,
  carYear,
  onWhatsappClick,
  ownerWhatsapp,
}) {
  const [shareOpen, setShareOpen] = React.useState(false);

  const financimientoLink = `https://docs.google.com/forms/d/e/1FAIpQLSefOJK-rvqjy_uz36h8rT5TuWZciywDeo99ae3sWXrnKfHz2w/viewform?usp=pp_url&entry.1457276942=${pageUrl}`;

  const whatsappLink = `https://wa.me/52${ownerWhatsapp}?text=Buen día, Mucho gusto, vi su publicación en seminuevossonora.com, me interesa tu auto. ${pageUrl}`;

  return (
    <div className="flex flex-col pt-8 gap-4 px-8">
      {carYear >= 2016 && (
        <Button className="bg-red-600 text-white">
          <a
            className="flex justify-center"
            href={financimientoLink}
            target="_blank"
            rel="noreferrer"
          >
            Financiamiento
          </a>
        </Button>
      )}
      <Button
        onClick={() => setShareOpen((prev) => !prev)}
        className="border-2 border-gray-400"
      >
        Compartir
      </Button>
      {shareOpen && (
        <div
          id="tooltip-click"
          role="tooltip"
          className="inline-block absolute z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm tooltip dark:bg-gray-700"
        >
          <div className="flex gap-2">
            <FacebookShareButton url={pageUrl}>
              <FacebookIcon size={32} />
            </FacebookShareButton>
            <TwitterShareButton url={pageUrl}>
              <TwitterIcon size={32} />
            </TwitterShareButton>
            <WhatsappShareButton url={pageUrl}>
              <WhatsappIcon size={32} />
            </WhatsappShareButton>
          </div>
        </div>
      )}
      <Button className="bg-brand-primary flex gap-2 items-center justify-center">
        <a
          className="flex items-center justify-center gap-2 w-full"
          onClick={onWhatsappClick}
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
        >
          <FaWhatsapp fontSize={18} />
          Contacto
        </a>
      </Button>
    </div>
  );
}
